import React from "react";
import {SalesPackageOption} from "../../../../components/SalesPackage/SalesPackageOption";
import {SalesPackage} from "../../../../components/SalesPackage";
import {VehicleGroup} from "../../../../model/vehicle";
import {strings} from "../../../../strings/strings";
import {sumInsuredFormat} from "../../../../utils/format";
import {getSnippetByName} from "../../../../api/snippetApiClient";
import {WIDGET_DURATION, WidgetTooltip} from "../../../../App";
import {ChatWidget} from "../../../../model/chatWidget";
import useSwitchToNewContent from "../../../../utils/hooks/useSwitchToNewContent";

interface CASCOPackage {
    vehicleGroup: VehicleGroup;
    premium: number;
    deductible: number;
    selected: boolean;
    onSelect: () => void;
    packageName: string;
    more?: React.ReactElement;
}

export const MTPLPackage = ({vehicleGroup, premium, deductible, selected, onSelect, packageName, more}: CASCOPackage) => {
    const showNewContent = useSwitchToNewContent()

    React.useEffect(() => {
        let timout: NodeJS.Timeout
        getSnippetByName(ChatWidget.TEMPLATE_HINT_PRICE).then(res => {
            timout = setTimeout(() => {
                WidgetTooltip?.open(res.text, WIDGET_DURATION)
            }, 1000)
        })

        return () => {
            clearTimeout(timout)
            WidgetTooltip?.close()
        }
    }, [])

    return (
        <SalesPackage name={packageName}
                      premium={premium}
                      selected={selected}
                      onSelect={onSelect}
                      popular={false}
                      totalPremium={0}
                      vehicleGroup={vehicleGroup}
                      more={more}>
            <SalesPackageOption name={strings.packageOptionMtplName}
                                tooltipPlacement={"left"}
                                tooltip={<ul>
                                    <li>{showNewContent ? strings.packageOptionMtplText1in2025 : strings.packageOptionMtplText1}</li>
                                    <li>{showNewContent ? strings.packageOptionMtplText2in2025 : strings.packageOptionMtplText2}</li>
                                </ul>}
                                covered={true}/>
            <SalesPackageOption
                name={`${strings.franchise} ${sumInsuredFormat(deductible)} ${strings.currencyUAH}`}
                tooltipPlacement={"left"}
                tooltip={<div><span
                    className={"accent"}>{strings.franchise2}</span>{strings.franchiseDescription}</div>}
                covered={true}/>
        </SalesPackage>
    )

};